
import {AfterContentChecked, ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, ViewChild} from '@angular/core';
import { SwiperComponent } from 'swiper/angular';
import { SwiperOptions } from 'swiper';
// import Swiper core and required modules
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import { DomSanitizer, Meta } from '@angular/platform-browser';
import {
  NavController,
  LoadingController,
  ModalController,
  Platform,
  ActionSheetController,
  ToastController
} from '@ionic/angular';
import { LangService } from 'src/app/services/lang.service';
import { RestService } from 'src/app/services/rest.service';
import { UtilService } from 'src/app/services/util.service';
import { LocationService } from 'src/app/services/location.service';
import {ExtendedProfile} from "../../../models/commons/extendedProfile";
import {Location} from "@angular/common";
// Pixel library importing
import { PixelService } from 'ngx-pixel';
import {Share} from "@capacitor/share";
import {ShareMenu} from "share-menu";
import {SeoProvider} from "../../services/seo";
import {filter} from 'rxjs/operators';
SwiperCore.use([Navigation, Pagination]);
@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit, AfterContentChecked {
  loadMostWanted: any;
  @ViewChild('swiper') swiper: SwiperComponent;
  @ViewChild('popover') popover;
  config3: SwiperOptions = {
    initialSlide: 1,
    slidesPerView: 3.3,
    spaceBetween: 60,
    navigation: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    allowSlidePrev: true,
    allowSlideNext: true,
    slideToClickedSlide: true,
  };
  isOpen = false;
  isMobile: boolean;
  isMobileSlide: boolean = false;
  langH: any;
  id: string;
  searchTop: any;
  showOverSearch: boolean;
  helpFocus: boolean;
  profile: any;
  dataDynamic: any[] = [];
  dataSlider: any[] = [];
  dataSearchSlider: any[] = [];
  maxAlbum = 4;
  seeAllAlbumbs: boolean;
  load: boolean;
  isAlbumsBigger: boolean;
  user: any;
  profileUpdate: any;
  profiles: any;
  genres: string[];

  skills: ExtendedProfile[] = [];
  socials: ExtendedProfile[] = [];
  profileSocials: ExtendedProfile[] = [];
  profileSkills: ExtendedProfile[] = [];
  profileGenres: ExtendedProfile = {
    values: [], label: '', user_field_id: null
  };
  profileInstruments: ExtendedProfile = {
    values: [], label: '', user_field_id: null
  };
  profilePrize: ExtendedProfile = {
    values: [], label: '', user_field_id: null
  };
  edit: boolean = true;
  location: string;
  selectedProfiles: any[] = [];
  helpBioNotEdit: boolean = false;
  activated: any[];
  instruments: any[];
  isSearching: boolean = false;
  isMacOS: boolean = false;
  isIOS: boolean = false;

  availableInstruments: string[] = [];
  disabledEdit: boolean = false;
  modalShowRegister: boolean;
  modalShowRegisterTelco: boolean;
  searchSection: any;
  rerenderProps: Array<number> = [1];
  banners: any[] = [];
  seeAllAlbumsEdit: boolean;
  sectionEdit: string = null;
  helpAlbum: boolean = false;


  constructor(
    public rest: RestService,
    public navCtrl: NavController,
    public actionSheetCtrl: ActionSheetController,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public util: UtilService,
    public platform: Platform,
    public domSanitizer: DomSanitizer,
    public zone: NgZone,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    public locationService: LocationService,
    public langService: LangService,
    public elementRef: ElementRef,
    private toastController: ToastController,
    private locationRouter: Location,
    private pixel: PixelService,
    public toastCtrl: ToastController,
    public seoService: SeoProvider,
    public meta: Meta,
    private router: Router,
  ) {
    if (this.platform.is('android') || this.platform.is('ios')) {
      this.isMobile = true;
    }
    this.langService.getLanguajeStorage().then((val => {
      if (val) {

        console.log('>>>XXX1-home', val);
        this.reloadTrans(val);
      } else {
        console.log('>>>XXX3');
        this.reloadTrans('es');
      }
    })).catch((err) => {
      console.log('>>>XXX5');
      this.reloadTrans('es');
    });



    this.profileUpdate = {
      profiles: [],
    };

    this.isMacOS = (navigator.userAgent.indexOf('Macintosh') > 0 && navigator.userAgent.indexOf('Safari') > 0 && navigator.userAgent.indexOf('Chrome') <= 0) ? true : false;
    this.isIOS = (navigator.userAgent.indexOf('iPhone') > 0) ? true : false;

  }

  private reloadTrans(lang) {
    this.translate.use(lang);
    this.langService.setTranslateLanguage(lang);
    this.langH = lang;
  }



  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.id = this.id.split('-')[0];
    //console.log('id', this.id);
    this.loadDataProfile();

    /*setTimeout(() => {
      this.rest.getStorage('user').then((val) => {
        this.user = val;
        console.log(val);
        if (!val) {
          this.navCtrl.navigateRoot('login');
        } else {
          this.loadDataProfile();
        }
      });

    }, 500);*/
    // https://v2.louderband.com/api/accounts/user-information/7275?
  }

  ionViewDidEnter() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.id = this.id.split('-')[0];
    //console.log('id', this.id);
    this.loadDataProfile();

    /*setTimeout(() => {
      this.rest.getStorage('user').then((val) => {
        this.user = val;
        console.log(val);
        if (!val) {
          this.navCtrl.navigateRoot('login');
        } else {
          this.loadDataProfile();
        }
      });

    }, 500);*/
  }

  outData2(ev) {
    //console.log(ev);
    if (ev.banners) {
      this.banners = ev.banners;
    }

    if (ev && ev.blur) {
      this.showOverSearch = false;
      this.searchTop = null;
      this.helpFocus = false;
    }
  }

  async getProfileInfo() {
    const auxLoading = await this.loadingCtrl.create({});
    await auxLoading.present();

    this.rest._get('accounts/basic-data').subscribe(resx => {
      const res: any = resx.body;
      this.profile = res;
      if(this.profile && this.profile.bio && this.profile.bio.trim() === '.' ){
        this.profile.bio = '';
      }
      this.getSliderProfile();
      this.getSearchSliderProfile();
      let params = {
        id: this.profile.user_id
      }
      this.rest._get('discs/user/' + this.profile.user_id).subscribe(async (resx2) => {
        const res2: any = resx2.body;
        let auxRes: any = res2;
        auxRes = auxRes.data.discs;
        auxRes = auxRes.sort((a, b) => new Date(b.release_date).getTime() - new Date(a.release_date).getTime());
        this.profile.albums = auxRes;
        let auxAlbum = [];
        for (let index = 0; index < this.profile.albums.length; index++) {
          if (index < 9) {
            auxAlbum.push(this.profile.albums[index]);
          }
        }
        this.profile.albumsSort = auxAlbum;
        if (this.profile.albums.length > 6) {
          this.isAlbumsBigger = true;
        } else {
          this.isAlbumsBigger = false;
        }
        await auxLoading.dismiss();
      }, async (res) => {
        await auxLoading.dismiss();
        console.log(res);
      });
      const user = this.user;
      user.profile_image = res.profile_image;
      user.profile_cover = res.profile_cover;
      this.rest.storageSet('user', user);
      if (this.profile.profiles && this.profile.profiles.length > 0) {
        for (const profile of this.profile.profiles) {
          this.profileUpdate.profiles.push(profile.name);
        }
      }

      this.loadProfileEditLink();
      this.getExtendedProfile();
    }, async (rees) => {
      await auxLoading.dismiss();
      console.log('error loading data', rees);
    });
  }
  loadProfileEditLink() {
    /*his.parametersService.getById(2).then(res => {
      this.profile.edit_more = res.value;
    }).catch(res => {
      console.log('cant load edit link');
    });*/
  }

  outData(ev) {
    if (ev && ev.editProfile) {
      this.navCtrl.navigateForward('mi-perfil');
    }

    if (ev && ev.focus) {
      this.showOverSearch = true;
      if (ev.search === '') {
        this.searchTop = '';
      }
      setTimeout(() => {
        this.helpFocus = true;
      }, 1800);
    }

    if (ev && ev.login) {
      // this.openLogin();
      this.navCtrl.navigateRoot('/login')
    }

    if (ev && ev.home) {
      let url = '/home';
      this.locationRouter.go(url);
    }

    if (ev && ev.referred) {
      let url = '/referred';
      this.navCtrl.navigateRoot(url);
    }

    if (ev && ev.old) {
      // this.navCtrl.navigateRoot('/registro')
      this.gotoOldApp(ev.view);
    }


    if (ev && ev.search) {
      //console.log(ev.search);
      this.searchTop = ev.search;

    }

    if (ev && typeof ev.isMobile === 'boolean') {
      //console.log(ev);
      this.isMobile = ev.isMobile;
    }

  }

  gotoOldApp(view?) {
    //console.log(view);

    if (view) {
      this.navCtrl.navigateForward(view);
    } else {
      window.open('https://louderband.com/', '_self');
    }
  }

  public rerender(): void {
    this.rerenderProps[0]++;
  }

  ngAfterContentChecked() {
    if (this.swiper) {
      this.swiper.updateSwiper({})
    }

    this.cdRef.detectChanges();
  }

  async loadDataProfile() {
    const auxLoading = await this.loadingCtrl.create({
    });
    await auxLoading.present();
    this.rest._get('accounts/user-information/' + this.id, 'get').subscribe(response => {
      setTimeout(() => {
        auxLoading.dismiss();
      }, 1000);
      this.getProfiles();
      this.getGenres();
      this.getInstruments();

      const res: any = response.body;
      //console.log('profile');
      //console.log(res);
      this.profile = res;
      if(this.profile && this.profile.bio && this.profile.bio.trim() === '.' ){
        this.profile.bio = '';
      }
      this.metaDatos();
      //Termina Prueba Gender
      this.selectedProfiles = [...this.profile.profiles];
      this.getExtendedProfile();
      this.getSliderProfile();
      this.getSearchSliderProfile();
      this.rest._get('discs/user/' + this.profile.user_id, 'get').subscribe(res2 => {
        const resxx: any = res2.body;
        //console.log(resxx);
        let auxRes: any = resxx;
        auxRes = auxRes.data.discs;
        auxRes = auxRes.sort((a, b) => new Date(b.release_date).getTime() - new Date(a.release_date).getTime());
        this.profile.albums = auxRes;
        setTimeout(() => {
          this.load = true;
        }, 200);
      }, (errv) => {
        //this.loading.dismiss();
        console.error(errv);
        setTimeout(() => {
          this.load = true;
        }, 200);
      });
    }, (err) => {
      if (auxLoading) {
        auxLoading.dismiss();
      }
      console.error('There was an error loading this data', err);
    });
  }

  getSliderProfile() {

    this.rest._get('profile/content/' + this.profile.id, 'get')
      .subscribe(response => {
        const res: any = response.body;
        this.getDataProfile();
        //console.log(res);
        this.dataSlider = res.content;

      }, (resr) => {
        console.log(resr);
      });
  }

  getSearchSliderProfile() {

    this.rest._get('profile/searches/' + this.profile.id, 'get')
      .subscribe(response => {
        const res: any = response.body;
        this.dataSearchSlider = res.content;

      }, (resr) => {
        console.log(resr);
      });
  }

  getDataProfile() {
    let profiles: any[] = [];
    let dataP = '';
    if (this.profile.profiles) {
      //console.log(this.profile.profiles);
      for (const iterator of this.profile.profiles) {
        profiles.push(iterator.name);
      }
      dataP = profiles.toString();
      dataP = dataP.replace(/,/g, '.');
    }
    if (!profiles) {
      return;
    }

    this.rest._get('profile/fields/' + dataP + '/' + this.profile.user_id, 'get')
      .subscribe(response => {
        const res: any = response.body;
        //console.log(res);
        this.dataDynamic = res.fields;
        let aux: boolean;
        try {
          for (let ita of this.dataDynamic) {
            let typeAux = true;
            for (let iterator of ita.fields) {
              aux = false;
              //console.log(iterator);
              if (typeof iterator.values === "boolean") {
                typeAux = false;
              }
              if (typeAux && iterator.values && iterator.values.indexOf('[') >= 0) {
                aux = true;
              }
              if (aux && iterator.values && iterator.values.length > 0) {
                //console.log(iterator.values);
                iterator.values = JSON.parse(iterator.values);
              }
            }
            if (!typeAux) {
              ita.fields = ita.fields.sort((a1, b1) => b1.values - a1.values);
            }
            if (ita.type == 'social') {
              //console.log(ita);
              ita.fields = ita.fields.sort((b, a) => a.values.localeCompare(b.values));
            }
          }
        } catch (error) {
          console.error(error);
        }

        //console.log(this.dataDynamic);
      }, (resr) => {
        //this.loading.dismiss();
        console.log(resr);
      });
  }

  getLocation(country, administrative_area_level_1, administrative_area_level_2) {
    return this.locationService.getLocationName({
      administrative_area_level_1: administrative_area_level_1,
      administrative_area_level_2: administrative_area_level_2,
      country: country,
    });
  }

  getAlbumExtraInformation(album) {
    let information = '';
    let artists = JSON.parse(album.artists);
    if (artists && artists.length) {
      information += artists.join(',');
    }

    information += ' (' + (new Date(album.release_date)).getFullYear() + ')';
    return information;
  }

  seeMaxAlbums() {
    //this.maxAlbum = this.profile.albums.length;
    this.seeAllAlbumbs = true;
  }

  goToDetails(item) {
    switch (item.type) {
      case 'course':
        this.navCtrl.navigateForward('cursos/' + item.id);
        break;
      case 'lesson':
        this.navCtrl.navigateForward('servicios/'+ item.type +'/' + item.id);
        break;
      case 'sound-market':
        this.navCtrl.navigateForward('servicios/sound/' + item.id);
        break;
      default:
        break;
    }
  }

  goToDetailsServices(item) {
    this.navCtrl.navigateForward('busquedas-publicadas/' + item.subtype +'/' + item.id);
  }

  onSwiper(ev) {

  }

  onSlideChange() {
  }


  goToDisc(val, owner) {
    this.navCtrl.navigateForward('creditos/' + val.id);
  }
  showBioNotEdit() {
    if (this.edit) {
      this.scrolltoTop();
      this.helpBioNotEdit = !this.helpBioNotEdit;
    }
  }

  getProfiles() {
    return this.rest._get('profiles?per-page=0', 's').subscribe((resespone: any) => {
      const res: any = resespone.body;
      this.profiles = res.items;
      return res.items;
    }, (error) => {
      console.error('error: ', error);
      // this.loadingModal(error.message);
    });
  }

  getGenres() {
    return this.rest._get('fields/values/genres').subscribe((resespone: any) => {
      this.genres = resespone.body.values.map(genre => genre.label);
      return this.genres;
    }, (error) => {
      console.error('error: ', error);
    });
  }

  // Cargar Skill y mostrar Skill
  getExtendedProfile() {
    let requestProfile = '';
    for (let i = 0; i < this.profile.profiles.length; i++) {
      requestProfile = requestProfile + this.profile.profiles[i].name;
      if((this.profile.profiles.length - 1) !== i ) {
        requestProfile = requestProfile + '.';
      }
    }

    //this.profile.profiles
    this.rest._get('profile/fields/'+requestProfile+'/'+this.profile.user_id).subscribe((response: any) => {
      this.getProfileSkill(response.body);
      this.getProfileSocial(response.body);
      this.getProfileGenre(response.body);
      this.getProfileInstruments(response.body);
      this.getProfilePrize(response.body);
    }, (error) => {
      console.error('error: ', error);
    });
  }

  private getProfileSkill(extendedProfile: any) {
    this.skills = [];
    this.profileSkills = [];
    let skills = extendedProfile.fields.filter(sk => sk.type === 'group' && sk.view === 'details'
      && sk.fields && sk.fields.length > 0 && sk.fields[0].group
      && sk.fields[0].group.toLowerCase().trim().startsWith('checkbox '));
    skills = skills.reduce((sk1, sk2) => sk1.fields.concat(sk2.fields));
    if (Array.isArray(skills)) {
    for (const skill of skills) {
      const sk: ExtendedProfile = {label: skill.label, user_field_id: skill.user_field_id, values: skill.values};
      this.skills.push(sk);
      if (skill.values) {
        this.profileSkills.push(sk);
      }
    }
    }
  }

  private getProfileGenre(extendedProfile: any) {
    let genresProfile: any = extendedProfile.fields.find(g => (g.fields && g.fields.length > 0 && g.fields[0].label === 'Géneros'));
    if (genresProfile) {
      genresProfile = genresProfile.fields[0];
      let genresValue;
      try {
        genresValue = JSON.parse(genresProfile.values);
      } catch (e) {
        genresValue = [];
      }
      this.profileGenres = {
        user_field_id: genresProfile.user_field_id,
        values: genresValue,
        label: genresProfile.label
      };
    }
  }

  private getProfileInstruments(extendedProfile: any) {
    let instrumentsProfile = extendedProfile.fields.find(g => (g.fields && g.fields.length > 0 && g.fields[0].label === 'Instrumentos'));
    if (instrumentsProfile) {
      instrumentsProfile = instrumentsProfile.fields[0];
      let instrumentsList;
      try {
        const parsedInstrumentList = JSON.parse(instrumentsProfile.values);
        instrumentsList = parsedInstrumentList.map((i) => {
          if (typeof i === 'string') {
            return ({ instrument: i, level: 0 });
          }
          return ({ instrument: i.instrument, level: i.level });
        });
      } catch (e) {
        instrumentsList = [];
      }
      this.profileInstruments = {
        user_field_id: instrumentsProfile.user_field_id,
        values: instrumentsList,
        label: instrumentsProfile.label
      };
    }
  }

  private getProfilePrize(extendedProfile: any) {
    let prizeProfile = extendedProfile.fields.find(g => (g.fields && g.fields.length > 0 && g.fields[0].label === 'Premios'));
    if (prizeProfile) {
      prizeProfile = prizeProfile.fields[0];
      let prizeValues;
      try {
        prizeValues = JSON.parse(prizeProfile.values);
      } catch (e) {
        prizeValues = [];
      }
      this.profilePrize = {
        user_field_id: prizeProfile.user_field_id,
        values: prizeValues,
        label: prizeProfile.label
      };
    }
  }

  private getProfileSocial(extendedProfile: any) {
    this.socials = [];
    this.profileSocials = [];
    let socials: any = extendedProfile.fields.find(sc => (sc.type && sc.type === 'social'));
    socials = socials ? socials.fields : [];
    for (const social of socials) {
      const scial: ExtendedProfile = {
        label: social.label,
        user_field_id: social.user_field_id,
        values: social.values && social.values === '.' ? null : social.values,
        image: social.image
      };
      this.socials.push(scial);
      if(scial.values) {
        this.profileSocials.push(scial);
      }
    }
  }

  buildUrlSocial(social: any) {
    if(social.label === 'Instagram'){
      const baseUrl = 'https://www.instagram.com/';
      const encodedNickname = encodeURIComponent(social.values);
      window.open(baseUrl + encodedNickname, '_blank');
    }
    if(social.label === 'TikTok'){
      const baseUrl = 'https://www.Tiktok.com/@';
      const encodedNickname = encodeURIComponent(social.values);
      window.open(baseUrl + encodedNickname, '_blank');
    }
    if(social.label === 'YouTube'){
      const baseUrl = 'https://www.youtube.com/@';
      const encodedNickname = encodeURIComponent(social.values);
      window.open(baseUrl + encodedNickname, '_blank');
    }
    if(social.label === 'Twitter'){
      const baseUrl = 'https://www.twitter.com/';
      const encodedNickname = encodeURIComponent(social.values);
      window.open(baseUrl + encodedNickname, '_blank');
    }
    if(social.label === 'Facebook'){
      const baseUrl = 'https://www.Facebook.com/';
      const encodedNickname = encodeURIComponent(social.values);
      window.open(baseUrl + encodedNickname, '_blank');
    }
    if(social.label === 'Spotify'){
      window.open(social.values, '_blank');
    }
  }

  getInstruments() {
    return this.rest._get('fields/values/instruments').subscribe((resespone: any) => {
      this.availableInstruments = resespone.body.values.map(instrument => instrument.label);
      return this.availableInstruments;
    }, (error) => {
      console.error('error: ', error);
    });
  }
  scrolltoTop(): void {
    const top = this.elementRef.nativeElement.querySelector('#top');
    top.scrollIntoView({ behavior: 'smooth' });
  }
  showMobileSlide1() {
    this.isMobileSlide = false;
  }

  showMobileSlide2() {
    this.isMobileSlide = true;
  }

  presentPopover(e: Event) {
    this.popover.event = e;
    this.isOpen = true;
  }

  getPrizeName(prize: string) : string {
    const strings = prize.split('$*$', 2);
    return strings.length > 0 ? strings[0] : '';
  }

  getPrizeCategory(prize: string) : string {
    const strings = prize.split('$*$', 2);
    return strings.length > 1 ? strings[1] : '';
  }
  goToChat() {
    const email = new RegExp("^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$");
    if(this.util.token && this.util.user.msisdn === null
      || (this.util.token && this.util.user.msisdn !== null && (email.test(this.util.user.email) === true))) {
    this.util.setChatTargetUser(this.profile);
    let chat_link = location.origin + '/mensajes/usuario/' + this.profile.id;

    window.open(chat_link, '_self');
    }else if(this.util.token && this.util.user.msisdn !== null && (email.test(this.util.user.email) === false)){
      this.showModalRegisterTelco();
    }
    else {
      this.showModalRegister();
    }
  }
  gotoLogin() {
    this.navCtrl.navigateForward('/login');
    this.modalShowRegister = false;
  }
  gotoRegister() {
    this.navCtrl.navigateForward('/registro');
  }

  showModalRegister() {
    this.modalShowRegister = !this.modalShowRegister;
  }
  showModalRegisterTelco() {
    this.modalShowRegisterTelco = !this.modalShowRegisterTelco;
  }
  showAllAlbums() {
    this.seeAllAlbumbs = false;
  }

  shareProfileDesktop(){
    const url = 'https://louderband.com/perfiles/' + this.id;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(async () => {
        const toast = await this.toastCtrl.create({
          message: 'La URL se ha copiado al portapapeles.',
          duration: 2000,
          position: 'top'
        });
        await toast.present();
      }).catch((async ()=> {
        const toast = await this.toastCtrl.create({
          message: 'No se pudo copiar la URL al portapapeles.',
          duration: 2000,
          position: 'top'
        });
        await toast.present();
      }));
    };
  }

  shareDevice(index: number) {
    const element = document.querySelector('share-menu') as ShareMenu;
    element.targets[index].share(element);
  }

  showEditAlbums() {
    if (this.edit) {
      this.scrolltoTop();
      this.seeAllAlbumsEdit = !this.seeAllAlbumsEdit;
      this.sectionEdit = this.seeAllAlbumsEdit ? 'albumEdit' : null;
      this.disabledEdit = true;
    }
  }

  closeShowEditAlbums() {
    if (this.edit) {
      this.scrolltoTop();
      this.seeAllAlbumsEdit = !this.seeAllAlbumsEdit;
      this.sectionEdit = this.seeAllAlbumsEdit ? 'albumEdit' : null;
      this.disabledEdit = false;
    }
  }

  showAlbum() {
    if (this.edit) {
      this.scrolltoTop();
      this.helpAlbum = true;
      this.sectionEdit = this.helpAlbum ? 'album' : null;
      this.disabledEdit = true;
      this.seeAllAlbumsEdit = false;
    }
  }

  metaDatos(){
    this.seoService.customizeMetaPageInfo({
      title: `Louderband | ${this.profile?.name}`,
      description: this.profile?.bio?.substr(0, 147) + '...',
      url: `https://louderband.com/perfiles/${this.id}`,
      image: (this.profile.profile_image) ? (this.isMacOS ? (this.profile.profile_image).replace('webp', 'jpg') : this.profile.profile_image) : 'https://www.louderband.com/assets/imagen/Profile.svg',
      slug: '',
    });
  }
}
